@let isMobile = breakpoints() === "mobile";
@let paragraphColor = style().textColor | color;
<section [id]="idComponent" [style.background-color]="style().backgroundColor | color">
  <div class="container">
    @if (isMobile) {
      <div class="row">
        <div class="col-xs-12 col-lg-12">
          @if (title()) {
            <app-title [titles]="[title()]" class="title-section" />
          }
        </div>
      </div>
    }
    <div class="row">
      @if (!isMobile) {
        <aside class="col-lg-4 sticky">
          @if (title()) {
            <app-title [titles]="[title()]" class="title-section" />
          }
          @for (item of items(); track item; let i = $index) {
            @if (item.title && item.video) {
              <div (click)="goToSection(item.title.text)" [class.item--active]="i === activeItem()" class="item">
                @if (item.title; as title) {
                  <app-title [titles]="[title]" class="title" />
                }
                @if (item.text; as text) {
                  <p [innerHTML]="text" class="paragraph" [style.color]="paragraphColor"></p>
                }
              </div>
            }
          }
        </aside>
      }
      <div class="col-xs-12 col-lg-7 col-lg-offset-1">
        @for (item of items(); track item) {
          @if (item.title; as title) {
            @if (isMobile && item.title) {
              <app-title [titles]="[title]" />
            }
            @if (isMobile && item.text) {
              <p [innerHTML]="item.text" [style.color]="paragraphColor" class="paragraph"></p>
            }
            @if (item.video; as video) {
              <app-video
                #videoElements
                [id]="item.title.text"
                [isLoop]="!!video.isLoop"
                [isMuted]="!!video.isMuted"
                [isPlayFullscreen]="data().isPlayFullscreen"
                [isResetAfterFullscreen]="data().isResetAfterFullscreen"
                [isHidePosterGoingFullscreen]="true"
                [mp4Url]="video.mp4Url"
                [previewImage]="video.image"
                [style]="{ width: isMobile ? '366px' : '700px', height: isMobile ? '242px' : '467px' }"
                [webmUrl]="video.webmUrl"
                class="video" />
            }
          }
        }
      </div>
    </div>
  </div>
</section>
